<div class="overlay"></div>
<section class="options-section">
    <div class="match-options">
        <div class="options details" (click)="openMatchDetails()">Match Details</div>
        <hr class="line">
        <div class="options follow" (click)="navigateToPlayers()">Manage Followed Players</div>
        <button (click)="closeDrawer()" class="options cancel">Cancel</button>
    </div>
</section>